import type { HTMLProps, PropsWithChildren, JSX } from "react";
import { clsx } from "../utils/clsx";
import { DeliveryCarIcon, GinBottlesIcon, GinBoxIcon } from "./icons";
import { VerticalDivider } from "./divider";
import type { ParagraphProps } from "./typography";
import { Paragraph } from "./typography";
import type { IconProps } from "./icons/types";

type PromoLineProps = PropsWithChildren<HTMLProps<HTMLDivElement>>;

export function PromoLine({
  className,
  children,
  ...props
}: PromoLineProps): JSX.Element {
  return (
    <section
      className={clsx(
        "bg-cgc-green-40 flex min-h-[39px] w-full items-center justify-center py-1 md:py-0 lg:h-[39px]",
        className,
      )}
      {...props}
    >
      {children}
    </section>
  );
}

function Benefit({ children }: PropsWithChildren): JSX.Element {
  return (
    <div className="flex w-[95px] flex-col items-center gap-x-2.5 gap-y-1 sm:w-auto lg:flex-row">
      {children}
    </div>
  );
}

function BenefitParagraph(props: ParagraphProps): JSX.Element {
  return (
    <Paragraph
      {...props}
      className={clsx(
        "text-cgc-blue text-[11px] font-semibold sm:text-base",
        props.className,
      )}
    />
  );
}

function BenefitDivider(props: IconProps): JSX.Element {
  return (
    <VerticalDivider
      {...props}
      className={clsx("mx-3 h-6 sm:mx-10", props.className)}
    />
  );
}

export interface BenefitsPromoLineProps {
  className?: string;
}
export function BenefitsPromoLine({
  className,
}: BenefitsPromoLineProps): JSX.Element {
  return (
    <PromoLine
      className={clsx(
        "bg-cgc-green-20 lg:promo-line-h flex h-[60px] flex-row items-center justify-around px-[15px] py-1.5 sm:justify-center",
        className,
      )}
    >
      <Benefit>
        <GinBoxIcon className="h-[25px] lg:h-[30px]" />{" "}
        <BenefitParagraph>No commitment</BenefitParagraph>
      </Benefit>
      <BenefitDivider />
      <Benefit>
        <DeliveryCarIcon className="h-[25px] lg:h-[30px]" />{" "}
        <BenefitParagraph>Free delivery</BenefitParagraph>
      </Benefit>
      <BenefitDivider />
      <Benefit>
        <GinBottlesIcon className="h-[25px] lg:h-[30px]" />{" "}
        <BenefitParagraph>Unique gins</BenefitParagraph>
      </Benefit>
    </PromoLine>
  );
}
